// action
export const getBrand = (state, val) => {
  state.brands = val
}

export const listBrand = (state, temp) => {
  state.lists = temp
}

export const brandForm = (state, val) => {
  state.brand = val
}

export const getGroupPrincipal = (state, val) => {
  state.groupPrincipals = val
}

export const groupForm = (state, val) => {
  state.groupForm = val
}
